module.exports = __webpack_public_path__ + "img/md5-normal3.e5d675cc.png";